let getWeigthProductModal = null;

$(document).ready(function () {
  var maxDecimals = 2;

  getWeigthProductModal = function (productId, quantity = 0, cartIndex = null) {
    return $.ajax({
      type: 'POST',
      url: '/api/v1/private/products/get-weigth-product-modal',
      data: {
        product_id: productId,
        quantity,
        cartIndex,
      },
    })
      .done(function (data) {
        if (data.html) {
          if ($('#weightProductModal').length) {
            $('#weightProductModal').remove();
            $('modal-backdrop').remove();
          }
          $('#content').append(data.html);
          setTimeout(() => {
            $('#weightProductModal').modal('show');
          }, 300);
        }
      })
      .fail(function (data) {});
  };

  $(document).on('click', '.show-weight-product-modal', function () {
    const productId = $(this).attr('data-product-id');
    const cartIndex = $(this).attr('data-cart-index');
    const quantityInput = $(this)
      .closest('.product-qty-container')
      .find('.cart-product-amount');
    const quantity = quantityInput.val();

    getWeigthProductModal(productId, quantity, cartIndex);
  });

  $(document).on('change', '#is_weight_product', function (e) {
    e.preventDefault();
    const weightProductChecked = $(this).is(':checked');
    const isVolumeCheckbox = $('#is_volume');
    const isMenuProductCheckBox = $('#is_menu_product');
    const openPriceCheckBox = $('#open-price');
    if (weightProductChecked) {
      isVolumeCheckbox.prop('checked', false).prop('disabled', true);
      isMenuProductCheckBox.prop('checked', false).prop('disabled', true);
      openPriceCheckBox.prop('checked', false).prop('disabled', true);
    } else {
      isVolumeCheckbox.prop('disabled', false);
      isMenuProductCheckBox.prop('disabled', false);
      openPriceCheckBox.prop('disabled', false);
    }
  });

  function getCurrentValue() {
    return $('#weightValue').val();
  }

  function setCurrentValue(val) {
    $('#weightValue').val(val);
  }

  $(document).on('click', '.numpad-btn', function () {
    var key = $(this).data('key');
    var current = getCurrentValue().toString();

    if (current === '0' || current === '') {
      current = '';
    }

    if (key === 'back') {
      current = current.slice(0, -1);
    } else if (key === '.') {
      if (current.indexOf('.') === -1) {
        current = (current === '' ? '0' : current) + '.';
      }
    } else {
      if (current === '0') {
        current = key.toString();
      } else {
        var decimalIndex = current.indexOf('.');
        if (
          decimalIndex !== -1 &&
          current.length - decimalIndex - 1 >= maxDecimals
        ) {
          return;
        }
        current += key.toString();
      }
    }

    setCurrentValue(current === '' ? '0' : current);
  });

  $(document).on('click', '#add-weight-product-btn', function () {
    const $modal = $('#weightProductModal');
    const productId = $modal.data('product-id');
    const amount = parseFloat(getCurrentValue()) || 0;
    const originalPrice = parseFloat($(this).attr('data-product-price'));

    if (weightValue <= 0) {
      $('#weightValue').addClass('is-invalid');
      return;
    }

    $('#weightValue').removeClass('is-invalid');

    let allProducts = locationCart.products;
    let productInCart = false;

    if (allProducts.length > 0) {
      for (let product of allProducts) {
        if (product.product_id === productId) {
          if (!('product_extra' in product)) {
            let productIndex = locationCart.products.findIndex(
              (obj) => obj.product_id === product.product_id
            );
            if (productIndex !== -1) {
              locationCart.products[productIndex].amount =
                locationCart.products[productIndex].amount + amount;
              locationCart.products[productIndex].comment = comment;
              productInCart = true;
              break;
            }
          }
        }
      }
    }

    if (productInCart === false) {
      let product = {
        product_id: productId,
        amount: amount,
        comment: '',
        discount_percent: locationCart.order_discount_percent || 0,
        original_product_price: originalPrice,
        is_open_price: 0,
        is_takeaway: 0,
      };
      locationCart.products.unshift(product);
      locationCart.number_of_products =
        parseInt(locationCart.number_of_products) + 1;
    }

    let priceInclVat = originalPrice * amount;

    locationCart.amount = parseFloat(locationCart.amount) + priceInclVat;
    updateCartSummary();
    updateCartProducts();

    $modal.modal('hide');
  });

  $(document).on('click', '#update-weight-product-btn', function () {
    const $modal = $('#weightProductModal');
    const productId = $modal.data('product-id');
    const cartIndex = $modal.data('cart-index');
    const amount = parseFloat(getCurrentValue()) || 0;
    const originalPrice = parseFloat($(this).attr('data-product-price'));

    if (weightValue <= 0) {
      $('#weightValue').addClass('is-invalid');
      return;
    }

    $('#weightValue').removeClass('is-invalid');

    let priceInclVat = originalPrice * amount;

    let oldAmount = parseFloat(locationCart.products[cartIndex].amount);
    let oldPriceIncVat =
      parseFloat(locationCart.products[cartIndex].original_product_price) *
      oldAmount;
    locationCart.products[cartIndex].amount = amount;
    locationCart.amount =
      parseFloat(locationCart.amount) + priceInclVat - oldPriceIncVat;
    updateCartSummary();
    updateCartProducts();

    $modal.modal('hide');
  });

  $(document).on('show.bs.modal', '#weightProductModal', function () {
    $('#weightValue').removeClass('is-invalid');
  });
});
